/**
 * Sorts an array of objects with Quick Notes data based on the order of the HighlightedAttribute's displayed
 * @param {{badgeClasses: string[], children: string, type: string}}
 * highlightedAttrsArray - Array containing HighlightedAttributes components
 * @param {{type: string, highlightedAttr: React.JSX.Element, note: string}[]} quickNotesAttrsArray - Array containing objects with Quick Notes data
 * @returns {{type: string, highlightedAttr: React.JSX.Element, note: string}[]} The quickNotesAttrsArray sorted
 */
export const sortQuickNotes = (highlightedAttrsArray, quickNotesAttrsArray) => {
	// Early return for empty arrays - performance optimization
	if (!quickNotesAttrsArray.length) return [];
	if (!highlightedAttrsArray.length) return [...quickNotesAttrsArray];

	const filteredHighlightedAttrs = highlightedAttrsArray.filter(
		(attr) => attr
	);

	// Early return if no valid highlighted attributes
	if (!filteredHighlightedAttrs.length) return [...quickNotesAttrsArray];

	const highlightedAttrTypeToIndex = new Map();

	// Optimized loop for better performance
	for (let index = 0; index < filteredHighlightedAttrs.length; index++) {
		const attribute = filteredHighlightedAttrs[index];
		// Process only if attribute has valid props and type
		if (attribute?.props) {
			const { type } = attribute.props;
			// Process only if type exists
			if (type) {
				highlightedAttrTypeToIndex.set(type, index);
			}
		}
	}

	// Create a copy of the array to avoid mutation
	return [...quickNotesAttrsArray].sort((a, b) => {
		const aIndex = highlightedAttrTypeToIndex.get(a.type);
		const bIndex = highlightedAttrTypeToIndex.get(b.type);

		// Handle undefined indices (types not in highlightedAttrs)
		if (aIndex === undefined && bIndex === undefined) return 0;
		if (aIndex === undefined) return 1; // Unknown types go to end
		if (bIndex === undefined) return -1; // Known types go to beginning

		return aIndex - bIndex;
	});
};
